
import React, { useState, useEffect } from 'react'
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Cookies } from 'react-cookie';
import { useAuth } from '../../../hooks/useAuth';
import { Box, Divider, Grid, Typography, Button, InputBase, Container, Paper, IconButton } from '@mui/material'
import { auth, setCrfToken, setlogin } from '../../../services/user-services'
import { blueGrey, grey } from '@mui/material/colors'
import CaptchaUser from '../../captcha/captcha';
import Notification from "../../notification/notification"
// import { useRouter } from 'next/navigation'
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';
import { debounce } from 'lodash';

// import dynamic from 'next/dynamic'
// const WaitingView = dynamic(
//     () => import("../../Maps/detail/common/Progress/back-drop"),
//     { ssr: false }
// )


export default function RegSecurity(
    {
        onBack, 
        userPhone,
        num_check,
        sms_code
    }) {
    // const { onNext, onBack, last_name, username, email, mobileNumber } = props
    const { setAuth } = useAuth()
    const cookies = new Cookies()

    const [password, setPassword ] = useState('')
    // const [password2, setPassword2 ] = useState<string>('')
    const [loading, setLoading ] = useState(false)
    const [notiShow, setNotiShow] = useState(false)
    const [notiTitle, setNotiTitle] = useState('')
    const [notiType, setNotiType] = useState("success")
    const [passShow, setPassShow] = useState(false)
    const [captchView, setCaptchView ] = useState(num_check > 0 ? true : false)
    
    const [captcha, setCaptcha ] = useState('')
    const [captchaStatus, setCaptchaStatus ] = useState(false)
    // const router = useRouter()
    const navigate = useNavigate()
    const inputRef = React.useRef();
  
    useEffect(() => {
      inputRef.current?.focus();
    }, [inputRef]);
  
    const setTextInputRef = (element) => {
      inputRef.current = element;
    };

    const handlerCaptcha = (value) => {
        setCaptcha(value)
    }
    
    // const passMatch = () => {
    //     // setNotiShow(true)
    //     // setNotiTitle("رمز و تکرار آن یا هم متفاوت می باشد.")
    //     // setNotiType("error")
    //     return password === password2
    // }
    
    // const handleNext = () => {
    //     if(passMatch()){
    //         const dataRes = {password: password, password2: password2}
    //         console.log(dataRes)
    //         onNext(dataRes)
    //     }
    // }
    

    const handlerShow = () => {
        setPassShow(!passShow)
        inputRef.current?.focus();
    }

    const handlerBackNoti = () => {
        setNotiShow(false)
    }

    const handleLoginSubmit = async () => {
        // inputRef.current?.focus();
        setLoading(true)
        const data = await auth({
            'username' : userPhone, 
            'password' : password,
            'captcha_val' : captcha?.captcha_val,
            'captcha_key' : captcha?.captcha_key
        })
        // console.log(data);
        // console.log(data?.non_field_errors)
        if(data?.message && data?.Error)
        {
            setNotiShow(true)
            setNotiTitle(data?.message)
            setNotiType("error")
            setCaptchView(true)
            // setError("عبارت داخل عکس را با دقت وارد کنید")
        }else if(data?.user?.username)
        {
            const crfAccessToken = await setCrfToken({'username' : data?.user?.username, 'password' : password})
            // console.log(crfAccessToken)
            if (crfAccessToken?.refresh && crfAccessToken?.access){
                let dateExpire = new Date(Date.now() + (30 * 24 * 60 * 60 * 1000))
                cookies.set('refresh_teken', crfAccessToken.refresh, { path: '/',  expires: dateExpire });
                cookies.set('access_token', crfAccessToken.access, { path: '/',  expires: dateExpire });
                setAuth(data)
                // window.location = "/"
                // navigate(`/`)
                // navigate(-1)
                setNotiShow(true)
                setNotiTitle("عملیات با موفقیت انجام شد .")
                setNotiType("success")
                onBack({
                    close: true
                })
                navigate(`/user/myaccount/?menu=account`)
            }else{
                setNotiShow(true)
                setNotiTitle("نام کاربری و یا رمز عبور اشتباه است")
                setNotiType("error")
                setCaptchView(true)
                // navigate(`/user/logout`)
            }
            // window.location.href = window.location.pathname
        }else{
            setNotiShow(true)
            setNotiTitle("نام کاربری و یا رمز عبور اشتباه است")
            setNotiType("error")
            setCaptchView(true)
        }
        setCaptchaStatus(!captchaStatus)
        setLoading(false)
    }

    const handelSubmit = async () => {
        let resNum = 0
        // inputRef.current?.focus();
        // console.log('typeSMS', typeSMS);
        
        resNum = await handelRegisterSubmit()
        // if(typeSMS === 0)
        // {
        //     resNum = 1
        // }
        if(resNum === 1)
        {
            handleLoginSubmit()
        }
    }

    const handelRegisterSubmit = async () => {
        // inputRef.current?.focus();
        // e.preventDefault();
        // if(!passMatch())
        // {
        //     setNotiShow(true)
        //     setNotiTitle("رمز و تکرار آن یا هم متفاوت می باشد.")
        //     setNotiType("error")
        //     return
        // }
        let resNum = 0
        if(password.length < 5)
        {
            setNotiShow(true)
            setNotiTitle("رمز باید بیشتر از 5 کاراکتر می باشد.")
            setNotiType("error")
            return resNum
        }
        setLoading(true)
        setNotiShow(false)
        setNotiTitle('')
        const items = {
            phone: userPhone,
            sms_code: sms_code,
            new_password: password,
            captcha_val : captcha?.captcha_val,
            captcha_key : captcha?.captcha_key,
        }
        // const items = {password, 
        //     profile:{phone_user: userPhone}, 
        //     captcha:{
        //         captcha_val : captcha?.captcha_val,
        //         captcha_key : captcha?.captcha_key,
        //         sms_code : sms_code
        //     }};
        const regData = await setlogin(items)

        // console.log('regData', regData)
        if (regData) {
            if(regData?.Error)
            {
                if(regData?.message)
                {
                    setNotiShow(true)
                    setNotiTitle(regData?.message)
                    setNotiType("error")
                }
                setCaptchView(true)
            }else{
                // const dataRes = {password: password, password2: password2}
                // // console.log(dataRes)
                // onNext(dataRes)
                if(regData?.message)
                {
                    setNotiShow(true)
                    setNotiTitle(regData?.message)
                    setNotiType("success")
                }
                resNum = 1
                // handleBack()
                // navigate(`/user/login`)
            }
            // console.log(regData)
            // const data = await auth({username, password})
            // setAuth(data)
            // window.location.href = window.location.pathname
            // navigate(`/login`)
            // navigate(`/${authDataGroup?.name}`)
        }else{
            setNotiShow(true)
            setNotiTitle('ثبت نام با خطا روبرو شده است !!!')
            setNotiType("error")
            setCaptchView(true)
        }
        setCaptchaStatus(!captchaStatus)
        setLoading(false)
        return resNum
    }

	const onEnter = async (e) => {
	    if (e.key === "Enter") {
	      e.target.blur();
          await handelSubmit()
	    }
    }

    const handleChange = (e) => {
        const re = /^[a-zA-Z0-9.!@#$]+$/;
        if (e.target.value === "" || re.test(e.target.value))
        {
            setPassword( String(e.target.value) )
        }else{
            setNotiShow(true)
            setNotiTitle('لطفا با انگلیسی بنویسید')
            setNotiType("error")
        }
    };
    

  return (
      <Box 
            sx={{  
                bgcolor: 'background.paper', 
                margin: '0.5rem 1rem 0.5rem 0.5rem' 
            }}            
            >
            {loading &&
                // <WaitingView openWait={loading} onCloseClick={false} />
                <CircularProgress />
            }
            <div dir='rtl' className='text-right'>
                <Container maxWidth={'sm'} >
                    <Paper elevation={2} >
                        <div  className='w-full'>
                            <Box component="section" sx={{ p: 2 }}>
                                <div className='-mt-5 pb-5'>
                                    <Typography 
                                        fontFamily='vaziri' 
                                        component="div"
                                        variant="h6"
                                        color={grey[800]}
                                        >
                                        رمز عبور جدید را وارد کنید
                                    </Typography>
                                </div>
                                <div className='pb-3'>
                                    <Typography 
                                        fontFamily='vaziri_light' 
                                        component="div"
                                        variant="body2"
                                        color={grey[600]}
                                        >
                                        قبل از ثبت آگهی، لطفاً وارد حساب خود شوید.
                                    </Typography>
                                </div>
                                <div className='pb-3'>
                                    <Typography 
                                        fontFamily='vaziri_light' 
                                        component="div"
                                        variant="body2"
                                        color={grey[600]}
                                        >
                                        جهت امنیت حساب مشخصات حود را تکمیل نمایید
                                    </Typography>
                                </div>
                            </Box>
                            <div className='w-full text-center items-center px-5 mb-5' dir='rtl'>
                                <Paper
                                    // component="form"
                                    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: '100%' }}
                                    >
                                    <InputBase
                                        sx={{ ml: 1, flex: 1, fontSize: 16, textAlign: 'center'}}
                                        placeholder={'رمز عبور'}
                                        inputProps={{ 
                                            'aria-label': 'search ', 
                                            fontSize: 22,
                                            style:{
                                                fontSize: 24,
                                                fontFamily:'b_mitra',
                                            } 
                                        }}
                                        onKeyUp={onEnter}
                                        inputRef={setTextInputRef} 
                                        autoFocus
                                        type={passShow ? 'text' : 'password'}
                                        autoComplete="new-password"
                                        value={password}
                                        onChange = {handleChange}

                                        />
                                    {/* <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                                        <PhoneCallbackIcon />
                                    </IconButton> */}
                                    <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                                    <IconButton color="primary" sx={{ p: '10px' }} aria-label="directions" onClick={handlerShow}>
                                        {passShow ?
                                            <RemoveRedEyeIcon />
                                        :
                                            <VisibilityOffIcon />

                                        }
                                    </IconButton>
                                </Paper>
                            </div>
                            <Divider />
                            {captchView &&
                                <div className="w-full text-right">
                                    <CaptchaUser onBack={handlerCaptcha} reqCaptch={captchaStatus}/>
                                </div>
                            }
                            <Divider />
                            <div className='text-left m-2'>
                                <Button variant="contained" 
                                    color="primary" 
                                    sx={{px : 5, my : 2}}
                                    disabled={!password || (captchView && !captcha?.captcha_val)}
                                    onClick={handelSubmit}
                                    >
                                    <Typography 
                                        fontFamily="vaziri"
                                        component="span"
                                        variant="h6"
                                        color={blueGrey[50]}
                                        >
                                        تایید
                                    </Typography>
                                </Button>
                            </div>
                            <div>
                                <Notification
                                    viewNoti={notiShow}
                                    title={notiTitle} 
                                    severity={notiType}
                                    onBack={handlerBackNoti}
                                    />
                            </div>
                        </div>
                    </Paper>
                </Container>
            </div>
        </Box>
    )
}
